import { render, staticRenderFns } from "./JettonTypeFilter.vue?vue&type=template&id=457f6068"
import script from "./JettonTypeFilter.vue?vue&type=script&lang=js"
export * from "./JettonTypeFilter.vue?vue&type=script&lang=js"
import style0 from "./JettonTypeFilter.vue?vue&type=style&index=0&id=457f6068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports